import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, useWatch } from 'react-hook-form';
import { type z } from 'zod';

import { mensagemDeErro } from '@/lib/erros';
import { CampoSenha } from '@/ui/components/campo-senha';
import { MedidorForcaSenha } from '@/ui/components/medidor-forca-senha';
import { toast } from '@/ui/primitives/aviso';
import { Button } from '@/ui/primitives/button';
import { Dialog } from '@/ui/primitives/dialog';
import { Campo, Input } from '@/ui/primitives/input';
import { type CriarUsuarioRequest, criarUsuarioRequestSchema } from '@fiscoai/contracts';

import { useAlterarUsuarios } from './api';

export function DialogoNovoUsuario({
  aberto,
  aoMudar,
}: {
  aberto: boolean;
  aoMudar: (aberto: boolean) => void;
}) {
  const { criar } = useAlterarUsuarios();
  const form = useForm<z.input<typeof criarUsuarioRequestSchema>, unknown, CriarUsuarioRequest>({
    resolver: zodResolver(criarUsuarioRequestSchema),
    defaultValues: { nome: '', email: '', senha: '' },
  });
  const erros = form.formState.errors;
  const senha = useWatch({ control: form.control, name: 'senha' });
  const enviar = form.handleSubmit((dados) => {
    criar.mutate(dados, {
      onSuccess: () => {
        toast.success('Pessoa cadastrada', {
          description: 'Agora vincule-a às empresas em que trabalha.',
        });
        form.reset();
        aoMudar(false);
      },
      onError: (erro) => toast.error(mensagemDeErro(erro)),
    });
  });
  return (
    <Dialog
      aberto={aberto}
      aoMudar={aoMudar}
      titulo="Nova pessoa"
      descricao="A senha inicial deve ser trocada no primeiro acesso."
      acoes={
        <>
          <Button
            variante="fantasma"
            onClick={() => {
              aoMudar(false);
            }}
          >
            Cancelar
          </Button>
          <Button variante="primario" carregando={criar.isPending} onClick={() => void enviar()}>
            Cadastrar
          </Button>
        </>
      }
    >
      <form
        noValidate
        className="grid gap-4"
        onSubmit={(e) => {
          e.preventDefault();
          void enviar();
        }}
      >
        <Campo rotulo="Nome" erro={erros.nome?.message}>
          {(a) => <Input {...a} {...form.register('nome')} />}
        </Campo>
        <Campo rotulo="E-mail" erro={erros.email?.message}>
          {(a) => <Input type="email" {...a} {...form.register('email')} />}
        </Campo>
        <Campo rotulo="Senha inicial" ajuda="Pelo menos 12 caracteres." erro={erros.senha?.message}>
          {(a) => (
            <>
              <CampoSenha autoComplete="new-password" {...a} {...form.register('senha')} />
              <MedidorForcaSenha senha={senha} />
            </>
          )}
        </Campo>
      </form>
    </Dialog>
  );
}
